export const formSubmissionDictionary = {
  submitForm: 'Ushbu so’rovnomani to’ldirishingizni so’raymiz',
  submitFormWarningDescription:
    "Eslatma: So'rovnomani to'ldirishni boshlaganizdan keyin uni oxiriga yetkazmay chiqib ketsangiz, yana boshidan boshlashingiz kerak bo'ladi. ",
  later: 'Keyinroq',
  start: 'Boshlash',
  back: 'Ortga',
  continue: 'Davom etish',
  saveAndFinish: 'Saqlash va Tugatish',
  enterYourAnswer: 'Javobingizni kiriting',
  understand: 'Tushundim',
  resumeFormats: "Rezyume doc, docx va pdf formatda bo'lishi kerak",
  thanksFormSubmit: "So'rovnomani to'ldirganingiz uchun rahmat",
  employedText:
    "Agarda ish/amaliyot joyingizda o'zgarishlar bo'lsa, telefon orqali +99899 439 00 11 yoki telegram orqali @techjobsadmin profiliga murojaat qiling!",
  unEmployedText:
    "Techjobs kompaniyasi sizga faqat to'liq ish kuni bo'yicha takliflar bera oladi. Yarim va masofaviy ish kuni bo'yicha esa yordam ko'rsata olmaydi.",
}
